<template>
  <div>
    <v-dialog v-model="showFormModule" width="1200" persistent @keydown.esc="showFormModule = false" >
      <v-card class="pa-sm-10 pa-5">
        <div class="text-right">
          <v-icon @click="showFormModule = false" style="cursor: pointer">
            mdi-close
          </v-icon>
        </div>
        <FormModuleForm
          :action="action"
          :item="FormModule"
          @item-created="handleCreate"
          @item-updated="handleUpdate"
        />
      </v-card>
    </v-dialog>

    <WarningDialog
      ref="WarningDialogRef"
      :loading="deleting"
      @action="handleDelete"
    />

    <v-row class="mt-5">
      <v-col>
        <FormModuleList
          @setToEdit="handleSetToEdit"
          @showWarning="showWarning"
          :loading="loadingFormModules"
          :searchInput="searchInput"
          :formModules="list"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import WarningDialog from "../../components/WarningDialog.vue";
import FormModuleForm from "../../components/FormModule/FormModuleForm.vue";
import FormModuleList from "../../components/FormModule/FormModuleList.vue";
import { mapGetters, mapMutations } from "vuex";
import axios from "axios";

export default {
  name: "FormModule",
  components: {
    FormModuleForm,
    FormModuleList,
    WarningDialog,
  },
  props: ["searchInput", "formModuleList", "loadingFormModules"],
  data() {
    return {
      loading: false,
      showFormModule: false,
      action: "create",
      FormModule: "",
      deleting: false,
    };
  },
  computed: {
    ...mapGetters(["formModules"]),
    list() {
      return this.formModuleList
        ? this.formModuleList
        : this.formModules
        ? this.formModules
        : [];
    },
  },
  methods: {
    ...mapMutations([
      "pushFormModule",
      "updateFormModule",
      "removeFormModule",
      "setWarning",
      "setAlert",
      "pushDoctorFormModules",
      "updateDoctorFormModules",
    ]),
    handleCreate(FormModule) {
      this.pushFormModule(FormModule);
      this.pushDoctorFormModules(FormModule);
      this.showFormModule = false;
    },
    handleUpdate(FormModule) {
      this.updateFormModule(FormModule);
      this.updateDoctorFormModules(FormModule);
      this.showFormModule = false;
    },
    handleSetToEdit(FormModule) {
      this.action = "update";
      this.FormModule = FormModule;
      this.showFormModule = true;
    },
    setToCreate() {
      this.FormModule = { description: "", content: "" };
      this.action = "create";
      this.showFormModule = true;
    },
    showWarning(FormModule) {
      this.FormModule = FormModule;
      this.$refs.WarningDialogRef.description = `¿Seguro que desea eliminar "${FormModule.description}"?`;
      this.$refs.WarningDialogRef.show = true;
    },
    async handleDelete() {
      try {
        this.deleting = true;
        const res = await axios.delete(`/api/formModule/${this.FormModule.id}`);
        this.warning = false;
        const { message } = res.data;
        this.setAlert({
          show: true,
          color: "success",
          icon: "mdi-check-circle",
          timeout: 4000,
          text: message,
        });
        this.removeFormModule(this.FormModule);
        this.removeDoctorFormModules(this.FormModule);
      } catch (error) {
        console.log(error);
        this.setAlert({
          show: true,
          color: "error",
          icon: "mdi-alert-remove",
          text: error.response.data.message,
        });
      } finally {
        this.deleting = false;
        this.$refs.WarningDialogRef.show = false;
      }
    },
  },
};
</script>
